import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendVerificationCode } from 'services/pod';
import { ISendVerificationCodePayload } from 'services/pod/types';
import { fixPhoneFormat } from 'services/common/common.service';
import { ICommonResponse } from 'services/types';

export const ThunkSendVerificationCode = createAsyncThunk<
  ICommonResponse<string>,
  ISendVerificationCodePayload
>('pod/sendVerificationCode', data => {
  let phone = null;

  if (data?.phoneNumber) {
    return fixPhoneFormat(data?.phoneNumber).then(res => {
      phone = res.data.data;
      return sendVerificationCode({ ...data, phoneNumber: phone }).then(r => r.data);
    });
  }

  return sendVerificationCode(data).then(r => r.data);
});
